export default function auth({ next, router }) {
    if (!localStorage.token) {
      return router.push({ name: 'login' });
    }
  
    return next();
  }